import React, { useState, useEffect, useContext } from "react";
import DualPricing from "./DualPricing";
import Surcharge from "./Surcharge";
import { getEmsBootEquipments } from "../../../../api";
import NewToProcessing from "./NewToProcessing";
import { IoMdCheckmark } from "react-icons/io";
import CustomRateDesk from "./CustomRateDesk";
import FlatRatePricing from "./FlatRatePricing";
import TieredPricing from "./TieredPricing";
import ICPlusPricing from "./ICPlusPricing";
import { Stack } from "@mui/material";
import ToggleSwitch from "./input-elements/ToggleSwitch";
import { EquipmentContext } from "../useContext/context";
import config from "../../../../config";
import Select from "react-select";
import { id } from "date-fns/locale";
import SlidingButton from "../v2/input-elements/SlidingButton";

const renderModel = (
    model,
    emsEquipments,
    setFormDataByKeyValue,
    errors,
    form_data,
    allEquipments,
    removeError,
    selectedEquipments,
) => {
    switch (model) {
        case "dual_pricing":
            return (
                <DualPricing
                    selectedEquipments={selectedEquipments}
                    emsEquipments={emsEquipments}
                    setFormDataByKeyValue={setFormDataByKeyValue}
                    errors={errors}
                    form_data={form_data}
                    allEquipments={allEquipments}
                    removeError={removeError}
                />
            );
        case "surcharge":
            return (
                <Surcharge
                    selectedEquipments={selectedEquipments}
                    emsEquipments={emsEquipments}
                    setFormDataByKeyValue={setFormDataByKeyValue}
                    errors={errors}
                    form_data={form_data}
                    allEquipments={allEquipments}
                    removeError={removeError}
                />
            );
        case "flat_rate":
            return (
                <FlatRatePricing
                    selectedEquipments={selectedEquipments}
                    emsEquipments={emsEquipments}
                    setFormDataByKeyValue={setFormDataByKeyValue}
                    errors={errors}
                    form_data={form_data}
                    allEquipments={allEquipments}
                    removeError={removeError}
                />
            );
        case "tiered":
            return (
                <TieredPricing
                    selectedEquipments={selectedEquipments}
                    emsEquipments={emsEquipments}
                    setFormDataByKeyValue={setFormDataByKeyValue}
                    errors={errors}
                    form_data={form_data}
                    allEquipments={allEquipments}
                    removeError={removeError}
                />
            );
        case "ic_plus":
            return (
                <ICPlusPricing
                    selectedEquipments={selectedEquipments}
                    emsEquipments={emsEquipments}
                    setFormDataByKeyValue={setFormDataByKeyValue}
                    errors={errors}
                    form_data={form_data}
                    allEquipments={allEquipments}
                    removeError={removeError}
                />
            );
        default:
            return "";
    }
};

const PricingModel = ({
    appId,
    pricingModels,
    setFormDataByKeyValue,
    setFormDataByComplete,
    errors,
    form_data,
    allEquipments,
    removeError,
    preappData,
    preappBillingData,
    template,
    mccList,
    emsOfficeList,
}) => {
    const [selectedEquipments, setSelectedEquipments] = useState([]);

    const [emsEquipments, setEmsEquipments] = useState([]);
    const { org_id } = useContext(EquipmentContext);
    const [priceData, setPriceData] = useState();

    const getTitle = (id) => {
        switch (id) {
            case 1:
                return "Qualified";
            case 3:
                return "Mid-Qualified";
            case 4:
                return "Non-Qualified";
            case 32:
                return "Amex Tier 1";
            case 33:
                return "Amex Tier 2";
            case 34:
                return "Amex Tier 3";
            case 49:
                return "Amex Tier 4";
            case 35:
                return form_data.pricing_model === "ic_plus"
                    ? "Amex IC Plus"
                    : "Amex Flat";
            case "additionalCharges":
                return "Additional Charges";
            default:
                return "";
        }
    };

    const qualifiedTiered = [1, 3, 4];
    const qualifiedDebitTiered = [39, 41, 40];
    const qualifiedDualPricing = [35, 17];
    const qualifiedFlatRateAndIcPlus = [2, 5, 35, 38];
    const qualifiedSurcharge = [35, 17, 5, 6, 39, 40, 41];
    const amexTiered = [32, 33, 34, 49];
    const amexFlat = [35];
    const amexIcPlus = [35];
    const additionalCharges = [
        28, 19, 42, 18, 43, 12, 14, 29, 13, 11,

        46, 20, 47, 48, 22,
    ];
    const qualifiedPairs = [
        { main: 1, debit: 39 },
        { main: 3, debit: 40 },
        { main: 4, debit: 41 },
    ];
    const getPricingMapped = (qualifiedType, pricingModel, prices) => {
        if (prices?.length && qualifiedType) {
            const mappedObject = {
                pinDebit: [],
                qualified: [],
                amexed: [],
                additionalCharges: [],
                dualPricing: {
                    rate: null,
                    monthlyFee: null,
                },
                surcharge: {
                    rate: null,
                    monthlyFee: null,
                    pinDebit: null,
                    signatureDebit: null,
                },
                flat_rate_and_ic: {
                    rate: null,
                    amex: null,
                    pinDebit: null,
                    network: null,
                },
            };
            prices.forEach((item) => {
                if (item?.id === 5) {
                    mappedObject.pinDebit["rate"] = item;
                }
                if (qualifiedType === "dual_pricing") {
                    if (qualifiedDualPricing.includes(item?.id)) {
                        if (item?.id === 35) {
                            mappedObject.dualPricing["rate"] = item;
                        } else if (item?.id === 17) {
                            mappedObject.dualPricing["monthlyFee"] = item;
                        }
                    }
                }
                if (
                    qualifiedType === "flat_rate" ||
                    qualifiedType === "ic_plus"
                ) {
                    if (qualifiedFlatRateAndIcPlus.includes(item?.id)) {
                        if (item?.id === 2) {
                            mappedObject.flat_rate_and_ic["rate"] = item;
                        } else if (item?.id === 5) {
                            mappedObject.flat_rate_and_ic["pinDebit"] = item;
                        } else if (item?.id === 35) {
                            mappedObject.flat_rate_and_ic["amex"] = item;
                        } else if (item?.id === 38) {
                            mappedObject.flat_rate_and_ic["network"] = item;
                        }
                    }
                }
                if (qualifiedType === "surcharge") {
                    if (qualifiedSurcharge.includes(item?.id)) {
                        if (item?.id === 35) {
                            mappedObject.surcharge["rate"] = item;
                        } else if (item?.id === 17) {
                            mappedObject.surcharge["monthlyFee"] = item;
                        } else if (item?.id === 5) {
                            mappedObject.surcharge["pinDebit"] = item;
                        } else if (item?.id === 6) {
                            mappedObject.surcharge["signatureDebit"] = item;
                        } else if (item?.id === 39) {
                            mappedObject.surcharge["qual"] = item;
                        } else if (item?.id === 40) {
                            mappedObject.surcharge["mid_qual"] = item;
                        } else if (item?.id === 41) {
                            mappedObject.surcharge["non_qual"] = item;
                        }
                    }
                }

                if (qualifiedType === "tiered") {
                    if (qualifiedTiered.includes(item?.id)) {
                        if (
                            !mappedObject.qualified.some(
                                (q) => q.item.id === item?.id,
                            )
                        ) {
                            mappedObject.qualified.push({
                                item,
                                label: getTitle(item?.id),
                            });
                        }
                    }
                    if (qualifiedDebitTiered.includes(item?.id)) {
                        if (
                            !mappedObject.qualified.some(
                                (q) => q.item.id === item?.id,
                            )
                        ) {
                            mappedObject.qualified.push({
                                item,
                                label: getTitle(item?.id),
                            });
                        }
                    }
                    if (pricingModel) {
                        let amexedData = amexTiered;
                        switch (pricingModel) {
                            case "flat_rate":
                                amexedData = amexFlat;
                                break;
                            case "ic_plus":
                                amexedData = amexIcPlus;
                                break;
                            case "tiered":
                                amexedData = amexTiered;
                                break;
                            default:
                                break;
                        }
                        if (amexedData.includes(item?.id)) {
                            if (
                                !mappedObject.amexed.some(
                                    (a) => a.item.id === item?.id,
                                )
                            ) {
                                mappedObject.amexed.push({
                                    item,
                                    label: getTitle(item?.id),
                                });
                            }
                        }
                    }
                }
                if (additionalCharges.includes(item?.id)) {
                    if (
                        !mappedObject.additionalCharges.some(
                            (ac) => ac.item.id === item?.id,
                        )
                    ) {
                        mappedObject.additionalCharges.push({
                            item,
                            label: getTitle("additionalCharges"),
                        });
                    }
                }
            });
            if (qualifiedType === "tiered") {
                const qualifiedModified = qualifiedPairs
                    .map((pair) => {
                        const mainObj = mappedObject.qualified.find(
                            (q) => q.item.id === pair.main,
                        );
                        const debitObj = mappedObject.qualified.find(
                            (q) => q.item.id === pair.debit,
                        );
                        if (mainObj && debitObj) {
                            return {
                                ...mainObj,
                                debit: debitObj.item,
                            };
                        }
                        return mainObj || null;
                    })
                    .filter(Boolean);
                mappedObject.qualified = qualifiedModified;
            }
            return mappedObject;
        }
    };
    useEffect(() => {
        getEmsBootEquipments({ org_id }).then((res) => {
            if (res.status) {
                setEmsEquipments(res.data);
            }
        });

        if (preappBillingData?.status) {
            if (preappBillingData?.status) {
                let mappedObject = getPricingMapped(
                    preappBillingData?.qualifiedtype,
                    preappBillingData?.pricing_model,
                    preappBillingData?.prices,
                );
                setSelectedEquipments(
                    preappBillingData?.billing?.equipment_json,
                );
                if (preappBillingData?.prices?.length) {
                    setFormDataByComplete({
                        qualifiedtype: preappBillingData?.qualifiedtype,
                        pricing_model: preappBillingData?.pricing_model,
                        ebt: preappBillingData?.billing?.is_ebt ? "yes" : "no",
                        fnf_number: preappBillingData?.billing?.fnf_number,
                        ebt_transactions:
                            mappedObject?.additionalCharges?.[7]?.item?.pivot
                                ?.dollars,
                        dual_pricing_rate:
                            mappedObject?.dualPricing?.rate?.pivot?.percent,
                        dual_pricing_monthly_fee:
                            mappedObject?.dualPricing?.monthlyFee?.pivot
                                ?.dollars,
                        dual_pricing_pin_debit_network_fee:
                            preappBillingData?.billing?.network_fee,
                        dual_pricing_pin_debit_rate:
                            mappedObject?.pinDebit?.rate?.pivot?.percent,
                        dual_pricing_pin_debit_per_transaction:
                            mappedObject?.pinDebit?.rate?.pivot?.dollars,
                        surcharge_rate:
                            mappedObject?.surcharge?.rate?.pivot?.percent,
                        surcharge_per_transaction:
                            mappedObject?.surcharge?.rate?.pivot?.dollars,
                        surcharge_monthly_fee:
                            mappedObject?.surcharge?.monthlyFee?.pivot?.dollars,
                        surcharge_pin_debit_rate:
                            mappedObject?.surcharge?.pinDebit?.pivot?.percent,
                        surcharge_pin_debit_per_transaction:
                            mappedObject?.surcharge?.pinDebit?.pivot?.dollars,
                        surcharge_pin_debit_network_fee:
                            preappBillingData?.billing?.network_fee,
                        surcharge_qual_debit_rate: "",
                        surcharge_qual_debit_per_transaction: "",
                        surcharge_mid_qual_debit_rate: "",
                        surcharge_mid_qual_debit_per_transaction: "",
                        surcharge_non_qual_debit_rate: "",
                        surcharge_non_qual_debit_per_transaction: "",
                        surcharge_signature_debit_rate: "",
                        surcharge_signature_debit_per_transaction: "",
                        flat_rate:
                            mappedObject?.flat_rate_and_ic?.rate?.pivot
                                ?.percent,
                        flat_rate_transaction:
                            mappedObject?.flat_rate_and_ic?.rate?.pivot
                                ?.dollars,
                        flat_rate_amex:
                            mappedObject?.flat_rate_and_ic?.amex?.pivot
                                ?.percent,
                        flat_rate_amex_transaction:
                            mappedObject?.flat_rate_and_ic?.amex?.pivot
                                ?.dollars,
                        flat_rate_pin_debit_network_fee:
                            preappBillingData?.billing?.network_fee,
                        flat_rate_pin_debit_rate:
                            mappedObject?.flat_rate_and_ic?.pinDebit?.pivot
                                ?.percent,
                        flat_rate_pin_debit_per_transaction:
                            mappedObject?.flat_rate_and_ic?.pinDebit?.pivot
                                ?.dollars,
                        tiered_qual_rate:
                            mappedObject?.qualified?.[0]?.item?.pivot?.percent,
                        tiered_qual_transaction:
                            mappedObject?.qualified?.[0]?.item?.pivot?.dollars,
                        tiered_qual_debit_rate:
                            mappedObject?.qualified?.[0]?.debit?.pivot?.percent,
                        tiered_qual_debit_per_transaction:
                            mappedObject?.qualified?.[0]?.debit?.pivot?.dollars,
                        tiered_mid_qual_rate:
                            mappedObject?.qualified?.[1]?.item?.pivot?.percent,
                        tiered_mid_qual_transaction:
                            mappedObject?.qualified?.[1]?.item?.pivot?.dollars,
                        tiered_mid_qual_debit_rate:
                            mappedObject?.qualified?.[1]?.debit?.pivot?.percent,
                        tiered_mid_qual_debit_per_transaction:
                            mappedObject?.qualified?.[1]?.debit?.pivot?.dollars,
                        tiered_non_qual_rate:
                            mappedObject?.qualified?.[2]?.item?.pivot?.percent,
                        tiered_non_qual_transaction:
                            mappedObject?.qualified?.[2]?.item?.pivot?.dollars,
                        tiered_non_qual_debit_rate:
                            mappedObject?.qualified?.[2]?.item?.pivot?.percent,
                        tiered_non_qual_debit_per_transaction:
                            mappedObject?.qualified?.[2]?.item?.pivot?.dollars,
                        amex_tier_one_rate:
                            mappedObject?.amexed?.[0]?.item?.pivot?.percent,
                        amex_tier_one_fee:
                            mappedObject?.amexed?.[0]?.item?.pivot?.dollars,
                        amex_tier_two_rate:
                            mappedObject?.amexed?.[1]?.item?.pivot?.percent,
                        amex_tier_two_fee:
                            mappedObject?.amexed?.[1]?.item?.pivot?.dollars,
                        amex_tier_three_rate:
                            mappedObject?.amexed?.[2]?.item?.pivot?.percent,
                        amex_tier_three_fee:
                            mappedObject?.amexed?.[2]?.item?.pivot?.dollars,
                        amex_tier_four_rate:
                            mappedObject?.amexed?.[3]?.item?.pivot?.percent,
                        amex_tier_four_fee:
                            mappedObject?.amexed?.[3]?.item?.pivot?.dollars,
                        tiered_amex_flat_rate:
                            mappedObject?.amexed?.[0]?.item?.pivot?.percent,
                        tiered_amex_flat_transaction:
                            mappedObject?.amexed?.[0]?.item?.pivot?.dollars,
                        tiered_amex_ic_plus_rate:
                            mappedObject?.amexed?.[0]?.item?.pivot?.percent,
                        tiered_amex_ic_plus_transaction:
                            mappedObject?.amexed?.[0]?.item?.pivot?.dollars,
                        tiered_pin_debit_network_fee:
                            preappBillingData?.billing?.network_fee,
                        tiered_pin_debit_rate:
                            mappedObject?.pinDebit?.["rate"]?.pivot?.percent,
                        tiered_pin_debit_per_transaction:
                            mappedObject?.pinDebit?.["rate"]?.pivot?.dollars,
                        ic_plus_rate:
                            mappedObject?.flat_rate_and_ic?.rate?.pivot
                                ?.percent,
                        ic_plus_transaction_fee:
                            mappedObject?.flat_rate_and_ic?.rate?.pivot
                                ?.dollars,
                        ic_plus_amex_rate:
                            mappedObject?.flat_rate_and_ic?.amex?.pivot
                                ?.percent,
                        ic_plus_amex_transaction_fee:
                            mappedObject?.flat_rate_and_ic?.amex?.pivot
                                ?.dollars,
                        ic_plus_pin_debit_network_fee:
                            preappBillingData?.billing?.network_fee,
                        ic_plus_pin_debit_rate:
                            mappedObject?.flat_rate_and_ic?.pinDebit?.pivot
                                ?.percent,
                        ic_plus_pin_debit_per_transaction:
                            mappedObject?.flat_rate_and_ic?.pinDebit?.pivot
                                ?.dollars,
                        setup_fee:
                            mappedObject?.additionalCharges?.[0]?.item?.pivot
                                ?.dollars,
                        monthly_access_fee:
                            mappedObject?.additionalCharges?.[1]?.item?.pivot
                                ?.dollars,
                        data_breach:
                            mappedObject?.additionalCharges?.[2]?.item?.pivot
                                ?.dollars,
                        monthly_minimum:
                            mappedObject?.additionalCharges?.[3]?.item?.pivot
                                ?.dollars,
                        semi_annual_tech_fee:
                            mappedObject?.additionalCharges?.[4]?.item?.pivot
                                ?.dollars,
                        voice_aru:
                            mappedObject?.additionalCharges?.[5]?.item?.pivot
                                ?.dollars,
                        batch_fee:
                            mappedObject?.additionalCharges?.[6]?.item?.pivot
                                ?.dollars,
                        returned_ach_item:
                            mappedObject?.additionalCharges?.[14]?.item?.pivot
                                ?.dollars,
                        avs_fee:
                            mappedObject?.additionalCharges?.[8]?.item?.pivot
                                ?.dollars,
                        auth_transaction:
                            mappedObject?.additionalCharges?.[9]?.item?.pivot
                                ?.dollars,
                        etf_fee:
                            mappedObject?.additionalCharges?.[10]?.item?.pivot
                                ?.dollars,
                        chargeback_fee:
                            mappedObject?.additionalCharges?.[11]?.item?.pivot
                                ?.dollars,
                        representment_fee:
                            mappedObject?.additionalCharges?.[12]?.item?.pivot
                                ?.dollars,
                        pre_dispute_fee:
                            mappedObject?.additionalCharges?.[13]?.item?.pivot
                                ?.dollars,
                    });
                }
            }
        }
    }, []);

    const handlePricingModelChange = (model) => {
        setFormDataByKeyValue("qualifiedtype", model.type);
    };

    return (
        <div className="pricing-model-container mt-3r">
            {template ? (
                <>
                    <div className="mb-3">
                        <h6 className="sub-heading">Template Name</h6>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter template name"
                            value={form_data.template_name || ""}
                            onChange={(e) =>
                                setFormDataByKeyValue(
                                    "template_name",
                                    e.target.value,
                                )
                            }
                        />
                        {errors?.template_name &&
                            Array.isArray(errors.template_name) &&
                            errors.template_name.map((error, index) => (
                                <span key={index} className="error-message">
                                    {error}
                                </span>
                            ))}
                    </div>
                    <div className="row">&nbsp;</div>
                    <div className="row">
                        <div className="col-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 col-sm-6 col-xs-6">
                            <div className="mb-3 mt-3">
                                <h6 className="sub-heading">MCC ID</h6>
                                <Select
                                    value={form_data.mcc_id}
                                    name="colors"
                                    options={mccList}
                                    onChange={(value) => {
                                        setFormDataByKeyValue("mcc_id", value);
                                    }}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    isClearable
                                />
                            </div>
                        </div>
                        <div className="col-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 col-sm-6 col-xs-6">
                            <div className="mb-3 mt-3">
                                <h6 className="sub-heading">EMS Office ID</h6>
                                <Select
                                    value={form_data.ems_office_id}
                                    name="colors"
                                    options={emsOfficeList}
                                    onChange={(value) => {
                                        setFormDataByKeyValue(
                                            "ems_office_id",
                                            value,
                                        );
                                    }}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    isClearable
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className={"col-12 col-md-12 col-lg-12"}>
                            <SlidingButton
                                handleChange={(_e, v) => {
                                    setFormDataByKeyValue("is_editable", v);
                                }}
                                title="Is Editable?"
                                value={form_data.is_editable}
                                options={[
                                    { key: "yes", value: "Yes" },
                                    { key: "no", value: "No" },
                                ]}
                                className="expedited-funding mt-4r"
                            />
                        </div>
                    </div>
                    <div className="row">&nbsp;</div>
                </>
            ) : (
                <></>
            )}

            <h6 className="sub-heading">Pricing Model</h6>
            <p className="sub-heading-lead">
                Select your preferred pricing model
            </p>

            <Stack
                direction={{ xs: "column", sm: "row" }}
                className="pricing-model-buttons"
            >
                {pricingModels.map((model) => (
                    <>
                        {org_id === config.paymentcloud.PAYCHEX_ORG_ID &&
                        model.type === "surcharge" ? (
                            <></>
                        ) : (
                            <button
                                type="button"
                                key={model.label}
                                className={
                                    form_data.qualifiedtype == model.type
                                        ? "active"
                                        : ""
                                }
                                onClick={() => handlePricingModelChange(model)}
                            >
                                {form_data.qualifiedtype == model.type ? (
                                    <IoMdCheckmark />
                                ) : (
                                    ""
                                )}{" "}
                                {model.label}
                            </button>
                        )}
                    </>
                ))}
            </Stack>

            {errors?.qualifiedtype &&
                Array.isArray(errors.qualifiedtype) &&
                errors.qualifiedtype.map((error, index) => (
                    <span key={index} className="error-message">
                        {error}
                    </span>
                ))}

            {renderModel(
                form_data.qualifiedtype,
                emsEquipments,
                setFormDataByKeyValue,
                errors,
                form_data,
                allEquipments,
                removeError,
                selectedEquipments,
            )}
        </div>
    );
};

export default PricingModel;
